import phoneCommitTypes from './commit-types';

const INITIAL_PHONE_STATE = {
  isAddingPhone: false,
  isEditingPhone: -1,
};

function phoneReducers(state = INITIAL_PHONE_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case phoneCommitTypes.RESET_PHONE_STATE:
      return { ...INITIAL_PHONE_STATE };
    case phoneCommitTypes.SET_IS_ADDING_PHONE:
      return {
        ...state,
        isAddingPhone: action.isAddingPhone,
      };
    case phoneCommitTypes.SET_IS_EDITING_PHONE:
      return {
        ...state,
        isEditingPhone: action.isEditingPhone,
      };
    default:
      return state;
  }
}

export default phoneReducers;
